"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGa = _interopRequireDefault(require("react-ga"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Event =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Event, _React$Component);

  function Event() {
    (0, _classCallCheck2["default"])(this, Event);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Event).apply(this, arguments));
  }

  (0, _createClass2["default"])(Event, [{
    key: "formatEventType",
    value: function formatEventType() {
      var eventType = this.props.eventType;
      return "on".concat(eventType[0].toUpperCase()).concat(eventType.substring(1));
    }
  }, {
    key: "wrapEventHandler",
    value: function wrapEventHandler() {
      var _this$props = this.props,
          children = _this$props.children,
          event = _this$props.event;
      var formattedEventType = this.formatEventType();
      var childEventHandler = children.props[formattedEventType];
      return (0, _defineProperty2["default"])({}, formattedEventType, function () {
        _reactGa["default"].event(event);

        childEventHandler();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].cloneElement(children, _objectSpread({}, children.props, {}, this.wrapEventHandler()));
    }
  }]);
  return Event;
}(_react["default"].Component);

exports["default"] = Event;
Event.propTypes = {
  event: _propTypes["default"].shape({
    category: _propTypes["default"].string.isRequired,
    action: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string,
    value: _propTypes["default"].number,
    nonInteraction: _propTypes["default"].bool
  }).isRequired,
  eventType: _propTypes["default"].oneOf(['click', 'change']).isRequired
};
Event.defaultProps = {};